import create from 'zustand'
import { persist } from 'zustand/middleware'
import api from '../utils/api'
const isEqual = require('lodash/isEqual')

const useEventsStore = create(
  persist(
    (set, get) => ({
      exportLoading: false,
      loading: false,
      events: [],
      error: false,
      eventsExport: null,
      params: {},
      initialize: () => {
        const events = get().events
        if (events) {
          set({
            events: events,
            exportLoading: false,
          })
        }
      },
      addEventFromNotification: (event) => {
        set((state) => {
          const eventExists = state.events.some(
            (existingEvent) => existingEvent.id === event.id
          )
          if (!eventExists) {
            return { events: [event, ...state.events] }
          }
        })
      },
      getEvents: async (params = null) => {
        const oldParams = get().params
        if (params.cleanData) {
          set((state) => ({
            ...state,
            loading: false,
            isNewPageLoading: false,
            error: false,
            params,
            events: [],
          }))
        }
        if (params) {
          const { limit, offset, ...paramsWithoutLimitOffset } = params
          const {
            limit: oldLimit,
            offset: oldOffset,
            ...oldParamsWithoutLimitOffset
          } = oldParams
        } else {
          set((state) => ({
            ...state,
            loading: state.events.length === 0,
            error: false,
          }))
          params = oldParams
        }

        const existingEvents = get().events || []
        const lastEvent = existingEvents[0]
        if (lastEvent && params && params.offset === oldParams.offset) {
          // params.createdAt = lastEvent.createdAt //review performance push notifications
        }
        try {
          set((state) => ({
            ...state,
            loading: true,
            error: false,
          }))
          const response = await api.get('/events', {
            params,
            includeToken: true,
          })
          const newEvents = response.data.data
          if (newEvents.length > 0) {
            const newEvents = response.data.data
            const eventsMap = new Map()
            existingEvents.forEach((event) => eventsMap.set(event.id, event))
            newEvents.forEach((event) => eventsMap.set(event.id, event))
            let updatedEvents = Array.from(eventsMap.values())
            updatedEvents.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )
            set({
              events: updatedEvents,
              loading: false,
              isNewPageLoading: false,
              error: false,
            })
          } else {
            set({
              loading: false,
              isNewPageLoading: false,
              error: false,
            })
          }
        } catch (error) {
          console.log('error', error)
          set({
            loading: false,
            isNewPageLoading: false,
            error: error,
          })
        }
      },
      exportEvents: async (params = null, callback) => {
        set((state) => ({
          ...state,
          exportLoading: true,
        }))
        const response = await api.get('/events', {
          params,
          includeToken: true,
        })
        set((state) => ({
          ...state,
          exportLoading: false,
        }))
        callback && callback(params, response?.data?.data)
      },
    }),
    {
      name: 'events-store',
      getStorage: () => sessionStorage,
    }
  )
)

useEventsStore.getState().initialize()

export default useEventsStore
